import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axiosInstance from "../../Axios";
import useAuth from "../../contexts/UserContext.tsx";
import "./MonthlyReportForm.css";
export const MonthlyReportForm = ({ setReportReload }) => {
  useNavigate();
  const { user, logout } = useAuth();

  const [district, setDistrict] = useState();
  const [type, setType] = useState();
  const [schoolTypes, setSchoolTypes] = useState([]);
  const [districts, setDistricts] = useState();
  const [schoolTypeOptions, setSchoolTypeOptions] = useState([]);

  // const handleMonthChange = (e) => {
  //     setMonth(e.target.value);
  // }

  const handleTypeChange = (e) => {
    setType(e.target.value);
  };

  const handleDistrictChange = (e) => {
    setDistrict(e.target.value);
  };

  const handleSelectAllChange = () => {
    // If all checkboxes are already selected, unselect them. Otherwise, select all.
    if (schoolTypes.length === schoolTypeOptions.length) {
      setSchoolTypes([]);
    } else {
      setSchoolTypes(schoolTypeOptions.map((option) => option.value));
    }
  };

  const handleGenReportClick = async () => {
    if (!district || !type || schoolTypes.length === 0) {
      toast.error("Please select all fields");
      return;
    }

    try {
      const date = new Date();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const res = await axiosInstance.post("/createJobForDistrictReport", {
        month: month,
        district_id: district,
        schools: [],
        type: type,
        school_types: schoolTypes,
        year: year,
        auth_token: user.auth_token,
      });
      if (res.data.data.message === "Invalid User") {
        toast.error("Invalid User");
        logout();
        return;
      }
      // navigate(`/report`);
      // navigate(`/report/${res.data.report_id}`);
      toast.success(
        "Report is being generated. Please check the reports table for status."
      );
      setReportReload(true);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const getAllDistrcts = useCallback(async () => {
    var district_array = user.view_access_list.district.split(",");
    //Remove the duplicate values from the array
    district_array = district_array
      .filter((value, index, self) => self.indexOf(value) === index)
      .map((district) => district.replace(/['"]+/g, ""))
      .sort();
    setDistricts(district_array);
    try {
      const res = await axiosInstance.get(
        `getDistricts?auth_token=${user.auth_token}`
      );
      let receivedDistricts = res.data.data.districts;
      const availableDistricts = receivedDistricts.filter((district) =>
        district_array.includes(district.dist_name)
      );
      console.log(availableDistricts);

      availableDistricts.sort((a, b) => a.dist_name.localeCompare(b.dist_name));

      setDistricts(availableDistricts);
    } catch (err) {
      toast.error(err.message);
    }
  }, [user.auth_token, user.view_access_list]);

  useEffect(() => {
    getAllDistrcts();
    var school_types_array = user.view_access_list.school_types.split(",");
    //Remove the duplicate values from the array
    school_types_array = school_types_array
      .filter((value, index, self) => self.indexOf(value) === index)
      .map((schoolType) => schoolType.replace(/['"]+/g, ""))
      .sort()
      .map((school_type) => {
        console.log(typeof school_type);
        return {
          label: school_type,
          value: school_type,
        };
      });
    setSchoolTypeOptions(school_types_array);
  }, [getAllDistrcts, user.view_access_list.school_types]);

  return (
    <div className="monthly-report-form-container m-1">
      <div className="monthly-report-form-input-field">
        <FormControl>
          <InputLabel id="demo-simple-select-label-type">Type</InputLabel>
          <Select
            sx={{ width: 130 }}
            labelId="demo-simple-select-label-type"
            id="demo-simple-select"
            value={type}
            defaultValue=""
            label="Type"
            onChange={handleTypeChange}
          >
            <MenuItem value="district">District</MenuItem>
            {/* <MenuItem value="school">School</MenuItem> */}
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel id="demo-simple-select-label-district">
            District
          </InputLabel>
          <Select
            sx={{ width: 170 }}
            labelId="demo-simple-select-label-district"
            id="demo-simple-select"
            value={district}
            defaultValue=""
            label="District"
            onChange={handleDistrictChange}
          >
            {districts &&
              districts.map((district, index) => (
                <MenuItem key={index} value={district.dist_id}>
                  {district.dist_name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <div className="checkbox-container">
          <FormControl fullWidth>
            <InputLabel id="checkbox-dropdown-label">School Types</InputLabel>
            <Select
              labelId="checkbox-dropdown-label"
              id="checkbox-dropdown"
              multiple
              defaultValue=""
              label="School Types"
              value={schoolTypes}
              onChange={() => {}}
              renderValue={(selected) => [...selected].join(", ")}
            >
              <MenuItem key="select-all" onClick={handleSelectAllChange}>
                <FormControlLabel
                  control={
                    <Checkbox
                      indeterminate={
                        schoolTypes.length > 0 &&
                        schoolTypes.length < schoolTypeOptions.length
                      }
                      checked={schoolTypes.length === schoolTypeOptions.length}
                    />
                  }
                  label="Select All"
                />
              </MenuItem>
              {schoolTypeOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={schoolTypes.includes(option.value)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSchoolTypes([...schoolTypes, option.value]);
                          } else {
                            setSchoolTypes(
                              schoolTypes.filter(
                                (type) => type !== option.value
                              )
                            );
                          }
                        }}
                      />
                    }
                    label={option.label}
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <Button
          onClick={handleGenReportClick}
          sx={{
            backgroundColor: "#3498db",
            width: "180px",
          }}
          variant="contained"
        >
          Generate Report
        </Button>
      </div>
    </div>
  );
};
